import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { DiscountPolicy } from 'src/features/discountPolicies/utils/types';

const RESOURCE = '/discounts/discount-policy/:policyId/';

type QueryFnType = typeof queryFn;

interface DTO {
    policyId: string;
}
const queryFn = ({ policyId }: DTO): Promise<DiscountPolicy> => {
    return axios.get(formatResourcePath(RESOURCE, { policyId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetDiscountPolicy, RESOURCE as DISCOUNT_POLICY_RESOURCE };
